/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon16Light = forwardRef('TimeClockFastIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 7.5a5.5 5.5 0 1 1 6 5.478v1.003A6.5 6.5 0 1 0 1.019 8h1.003A5.57 5.57 0 0 1 2 7.5Z" }),
        React.createElement("path", { d: "M7.5 3.902a.5.5 0 0 1 .5.5v2.325c0 .284.16.544.415.671l2.309 1.155a.5.5 0 1 1-.448.894L7.967 8.293A1.75 1.75 0 0 1 7 6.727V4.402a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M.797 9a.5.5 0 0 0 0 1H3a.5.5 0 0 0 0-1H.797Z" }),
        React.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M1.5 13a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H1.5Z" })));
});
